import { render, staticRenderFns } from "./DashClienteFiltro.vue?vue&type=template&id=c001e45c&"
import script from "./DashClienteFiltro.vue?vue&type=script&lang=js&"
export * from "./DashClienteFiltro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports